<template>
   <div class="four_zero_four">
       <img src="../assets/images/404.jpg" class="notfound" />
       <div class="btn_div">
           <span class="back" @click="goHome()">返回首页</span>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
           

        }
    },
    mounted(){

    },
    methods:{
      goHome(){
          this.$router.push({
              path:'/home'
          })
      }
    }
    
}
</script>

<style lang="scss" scoped>
.four_zero_four{
    position: relative;
    margin-top:1rem;
    padding-bottom:4rem;
    background:#f6f7f9;
}
.notfound{
    padding-top:8rem;
    height: 50%;
    width: 50%;
}
.btn_div{
    
    
}
.back{
    
    border:1px solid #38a0dd;
    border-radius: 5px;
    background: #38a0dd;
    padding:5px 30px;
    color:#fff;
    cursor: pointer;
    font-size:24px;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/notfound.vue